import { render } from "./Tournaments.vue?vue&type=template&id=6e65e9cc&scoped=true"
import script from "./Tournaments.vue?vue&type=script&lang=js"
export * from "./Tournaments.vue?vue&type=script&lang=js"

import "./Tournaments.vue?vue&type=style&index=0&id=6e65e9cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e65e9cc"]])

export default __exports__